var _g, _style, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOmradeskollenLogga2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Lager_1",
    x: "0px",
    y: "0px",
    viewBox: "-3 -3 745 689",
    style: {
      enableBackground: "new 0 0 739.6 683.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "deeditor_bgCarrier",
    strokeWidth: 0
  }, /*#__PURE__*/React.createElement("rect", {
    id: "dee_c_e",
    x: -3,
    y: -3,
    width: 745,
    height: 689,
    rx: 38.4,
    fill: "#00000000",
    strokeWidth: 0
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00000000;stroke:#1D1D1B;stroke-width:30;stroke-miterlimit:10;}\n\t.st1{fill:#FFFFFFFF;stroke:#1D1D1B;stroke-width:30;stroke-miterlimit:10;}\n\t.st2{fill:#00000000;stroke:#1D1D1B;stroke-width:25;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M372.6,80.2c126.6,0,229.1,102.6,229.1,229.1s-229.1,295-229.1,298.2S143.5,435.9,143.5,309.3  S246.1,80.2,372.6,80.2z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M203.9,345c-3-12.6-4.4-25.4-4.4-38.4c0-95,80.9-167,167-167c67.8,0,130.9,44.6,157.9,112.6",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M531.2,333.9c-15.1,91-101.1,152.6-192.2,137.4c-66.5-11-119.8-60.8-135.3-126.4",
    fill: "#000000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M532.8,344.3l-151.1-93.5c-8.4-5.2-19-5.2-27.3,0L201,344.5",
    fill: "#000000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M385.1,407.3h-39.4c-5.3,0-10.2-2.1-14.1-5.8c-3.7-3.7-5.8-8.6-5.8-13.9v-39.2c0.1-11,9-19.7,19.9-19.7h39.4  c11,0,19.8,8.7,19.9,19.7v39.2C404.9,398.5,395.9,407.3,385.1,407.3z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmradeskollenLogga2);
export default __webpack_public_path__ + "static/media/omradeskollen_logga2.0e23561599ba6ab72e70134f95cf94b4.svg";
export { ForwardRef as ReactComponent };